"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeverificationService = void 0;
class AgeverificationService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Chathost Age Verification Start
     * @param individualProfileId
     * @param requestBody
     * @returns ExternalAgeVerifictionResponse Successful Response
     * @throws ApiError
     */
    chathostChathostAgeVerificationStart(individualProfileId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/ageverification/start/{individual_profile_id}',
            path: {
                'individual_profile_id': individualProfileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Age Verification Resend
     * @param individualId
     * @param requestBody
     * @returns ExternalAgeVerifictionResponse Successful Response
     * @throws ApiError
     */
    chathostChathostAgeVerificationResend(individualId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/ageverification/resend/{individual_id}',
            path: {
                'individual_id': individualId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Age Verification Status
     * @returns ChathostAVStatus Successful Response
     * @throws ApiError
     */
    chathostChathostAgeVerificationStatus() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/ageverification/status',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Studio Age Verification Start
     * @param kycPersonId
     * @param requestBody
     * @returns ExternalAgeVerifictionResponse Successful Response
     * @throws ApiError
     */
    studioStudioAgeVerificationStart(kycPersonId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/ageverification/start/{kyc_person_id}',
            path: {
                'kyc_person_id': kycPersonId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Studio Age Verification Resend
     * @param individualId
     * @param requestBody
     * @returns ExternalAgeVerifictionResponse Successful Response
     * @throws ApiError
     */
    studioStudioAgeVerificationResend(individualId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/ageverification/resend/{individual_id}',
            path: {
                'individual_id': individualId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Studio Age Verification Status
     * @returns StudioAVStatus Successful Response
     * @throws ApiError
     */
    studioStudioAgeVerificationStatus() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/ageverification/status',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
exports.AgeverificationService = AgeverificationService;
